import React from "react";
import logo from "../../resources/images/logo/logo_teccc.png";
import { BsFacebook, BsTwitter, BsInstagram } from "react-icons/bs";
import { FaTiktok } from "react-icons/fa";

const Footer = () => {
  const socialLink = [
    <BsFacebook />,
    <BsTwitter />,
    <BsInstagram />,
    <FaTiktok />,
  ];

  return (
    <footer style={styles.footer}>
      <div className="upper" style={styles.upper}>
        <div className="brand-container" style={styles.brandContainer}>
          <div className="brand">
            <img src={logo} alt="logo" style={{ height: "70px" }} />
          </div>

          <ul style={styles.socialLinks}>
            {socialLink.map((link, index) => (
              <li key={index} style={styles.socialLinkItem}>
                {link}
              </li>
            ))}
          </ul>
        </div>
        {/*<div className="links" style={styles.links}>
          {links.map(({ title, data }, index) => {
            return (
              <div className="link" key={index} style={styles.link}>
                <h4>{title}</h4>
                <ul>
                  {data.map((link, index2) => (
                    <li key={index2}>{link}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>*/}
      </div>
      <div className="lower" style={styles.lower}>
        <span>&copy; Copyright Marco Encalada: TECCC </span>
        <span>2025</span>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    flexShrink: 0,
    backgroundColor: "#f8f9fa",
    padding: "20px",
    textAlign: "center",
  },
  upper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  brandContainer: {
    textAlign: "left",
  },
  socialLinks: {
    listStyle: "none",
    padding: 0,
    display: "flex",
    gap: "10px",
  },
  socialLinkItem: {
    fontSize: "24px",
    cursor: "pointer",
  },
  links: {
    display: "flex",
    gap: "40px",
  },
  link: {
    textAlign: "left",
  },
  lower: {
    borderTop: "1px solid #ddd",
    paddingTop: "10px",
  },
};

export default Footer;